<template>
  <v-card>
    <v-card-title>
      Tarjoaja
    </v-card-title>
    <v-card-text>
      <offerer-search :customer="newPerson"/>
      <v-radio-group
        v-model="newPerson.isCompany"
        @change="companyOrPersonChange()"
      >
        <v-radio
          label="Yksityishenkilö"
          color="primary"
          :value="false"
        />
        <v-radio
          label="Yritys"
          color="primary"
          :value="true"
        />
      </v-radio-group>
      <v-form
        ref="personForm"
        v-model="personFormValid"
      >
        <v-text-field
          v-if="newPerson.isCompany"
          v-model="newPerson.companyName"
          :rules="[rules.required]"
          required
          class="mb-1"
          outlined
          label="Yrityksen nimi"
        />
        <v-text-field
          v-model="newPerson.name"
          autocomplete="off"
          class="mb-1"
          outlined
          :label="newPerson.isCompany ? 'Edustajan nimi' : 'Tarjoajan nimi'"
          :rules="[rules.required]"
          required
        />
        <v-text-field
          v-model="newPerson.email"
          autocomplete="off"
          class="mb-1"
          outlined
          label="Sähköposti"
          :rules="[rules.required, rules.email]"
          required
        />
        <v-text-field
          v-model="newPerson.ssn"
          class="mb-1"
          autocomplete="off"
          outlined
          label="Henkilötunnus (valinnainen)"
          hint="Henkilötunnus saadaan sähköisen tunnistautumisen kautta."
        />
        <v-text-field
          v-if="newPerson.isCompany"
          v-model="newPerson.companyNumber"
          class="mb-1"
          outlined
          label="Y-tunnus (valinnainen)"
          hint="Asiakas voi täydentää tiedot allekirjoituksen yhteydessä."
        />
        <v-text-field
          v-model="newPerson.address"
          class="mb-1"
          autocomplete="off"
          outlined
          label="Osoite (valinnainen)"
          hint="Asiakas voi täydentää tiedot allekirjoituksen yhteydessä."
        />
        <v-row>
          <v-col
            cols="12"
            md="6"
            class="py-0"
          >
            <v-text-field
              v-model="newPerson.zip"
              class="mb-1"
              autocomplete="off"
              outlined
              label="Postinumero (valinnainen)"
              hint="Asiakas voi täydentää tiedot allekirjoituksen yhteydessä."
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
            class="py-0"
          >
            <v-text-field
              v-model="newPerson.city"
              class="mb-1"
              autocomplete="off"
              outlined
              label="Kaupunki (valinnainen)"
              hint="Asiakas voi täydentää tiedot allekirjoituksen yhteydessä."
            />
          </v-col>
        </v-row>
        <v-text-field
          v-model="newPerson.phone"
          class="mb-1"
          autocomplete="off"
          outlined
          label="Puhelin (valinnainen)"
          hint="Asiakas voi täydentää tiedot allekirjoituksen yhteydessä."
        />
        <v-text-field
          v-model="newPerson.nationality"
          class="mb-1"
          autocomplete="off"
          outlined
          label="Kansalaisuus (valinnainen)"
          hint="Asiakas voi täydentää tiedot allekirjoituksen yhteydessä."
        />
        <label v-if="!newPerson.isCompany">Vapautettu varainsiirtoveron maksamisesta:</label>
        <v-switch
          v-if="!newPerson.isCompany"
          v-model="newPerson.assetTransfer"
          :label="
            `${newPerson.assetTransfer ? 'Kyllä' : 'Ei'}`
          "
          class="mt-0"
          color="primary"
        />
        <label>Oletko, tai oletko ollut viimeisen vuoden aikana poliittisesti vaikutusvaltainen
          henkilö, tällaisen henkilön perheenjäsen tai läheinen yhtiökumppani?</label>
        <v-switch
          v-model="newPerson.pep"
          :label="`${newPerson.pep ? 'Kyllä' : 'Ei'}`"
          class="mt-0"
          color="primary"
        />
        <v-textarea
          v-if="newPerson.pep"
          v-model="newPerson.pepDescription"
          class="mb-1"
          autocomplete="off"
          outlined
          label="PEP-selite"
          hint="Asiakas voi täydentää tiedot allekirjoituksen yhteydessä."
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        text
        @click="closeOffererDialog()"
      >
        Peruuta
      </v-btn>
      <v-btn
        color="primary"
        text
        :disabled="!personFormValid"
        @click="addOfferer()"
      >
        Ok
      </v-btn>
    </v-card-actions>
    <v-dialog v-model="areYouSure" max-width="600">
      <v-card>
        <v-card-title>
          Henkilötieto löytyy asiakasrekisteristä
        </v-card-title>
        <v-card-text class="px-6 pt-0">
          Asiakasrekisterissä on jo henkilö jolla on sama nimi, henkilötunnus tai sähköposti.
          Oletko varma että haluta lisätä uuden henkilötiedon?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            text
            @click="areYouSure = false;"
          >
            Peruuta
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="addOfferer(true)"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import _ from 'lodash';
import { EventBus } from '@/utils';
import { apiPost } from '../api';

export default {
  name: 'OffererForm',
  components: {
    'offerer-search': () => import('@/components/offer/OffererSearch'),
  },
  props: {
    newPerson: {
      type: Object,
      default: () => {},
    },
    duplicates: {
      type: Object,
      default: () => ({
        offerers: false,
      }),
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    editing: {
      type: Object,
      default: () => ({}),
    },
    indexes: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    areYouSure: false,
    personFormValid: false,
    rules: {
      required: value => !!value || 'Pakollinen kenttä.',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Virheellinen sähköpostiosoite.';
      },
    },
  }),
  methods: {
    closeOffererDialog() {
      this.$bus.$emit('closeOffererDialog');
    },
    companyOrPersonChange() {
      this.newPerson.companyName = '';
      this.newPerson.companyNumber = '';
      this.newPerson.assetTransfer = false;
    },
    resetForm() {
      this.newPerson.isCompany = false;
      this.newPerson.companyName = '';
      this.newPerson.companyNumber = '';
      this.newPerson.name = '';
      this.newPerson.phone = '';
      this.newPerson.address = '';
      this.newPerson.zip = '';
      this.newPerson.city = '';
      this.newPerson.email = '';
      this.newPerson.ssn = '';
      this.newPerson.pep = false;
      this.newPerson.pepDescription = '';
      this.newPerson.nationality = 'Suomi';
      this.newPerson.signature = false;
      this.newPerson.assetTransfer = false;
      this.newPerson.touchSignature = {
        image: null,
        imageId: null,
      };
      EventBus.$emit('FORM_RESET');
    },
    async saveOfferer() {
      if (this.newPerson.id) {
        // update
        const params = {
          id: this.newPerson.id,
          ssn: this.newPerson.isCompany ? this.newPerson.companyNumber : this.newPerson.ssn,
          name: this.newPerson.isCompany ? this.newPerson.companyName : this.newPerson.name,
          address: this.newPerson.address,
          city: this.newPerson.city,
          zip: this.newPerson.zip,
          phone: this.newPerson.phone,
          email: this.newPerson.email,
        };
        const result = await apiPost('customer/updateperson', params);
        return result;
      }
      // create new
      const params = {
        ssn: this.newPerson.isCompany ? this.newPerson.companyNumber : this.newPerson.ssn,
        name: this.newPerson.isCompany ? this.newPerson.companyName : this.newPerson.name,
        address: this.newPerson.address,
        city: this.newPerson.city,
        zip: this.newPerson.zip,
        phone: this.newPerson.phone,
        email: this.newPerson.email,
      };
      if (this.newPerson.sure) {
        params.sure = true;
      }

      const result = await apiPost('customer/createperson', params);
      return result;
    },
    async addOfferer(sure = false) {
      this.$refs.personForm.validate();
      if (sure) {
        this.newPerson.sure = true;
      } else {
        delete this.newPerson.sure;
      }
      if (this.personFormValid && !this.editing.offerer) {
        const response = await this.saveOfferer();
        console.warn(response);
        if (response.message === 'Already exists' && !sure) {
          this.areYouSure = true;
        } else {
          if (response.personId) {
            this.newPerson.id = response.personId;
          }
          this.form.offerers.push(_.cloneDeep(this.newPerson));
          this.resetForm();
          this.$refs.personForm.resetValidation();
          this.newPerson.isCompany = false;
          this.$bus.$emit('closeOffererDialog');
        }
      } else if (this.personFormValid) {
        await this.saveOfferer();
        this.form.offerers[this.indexes.offerer] = _.cloneDeep(this.newPerson);
        this.newPerson.isCompany = false;
        this.resetForm();
        this.$refs.personForm.resetValidation();
        this.$bus.$emit('closeOffererDialog');
        this.editing.offerer = false;
        this.indexes.offerer = null;
      }
      const seen = new Set();
      this.duplicates.offerers = this.form.offerers
        .some(currentObject => seen.size === seen.add(currentObject.email).size);
    },
  },
};
</script>
